import * as types from '@/store/mutation-types';
import api from '@/store/api';
import { logAction } from '../logActions';
import log from '@/logger';
// import Vue from 'vue';

export const keywordUpdate = ({ commit, state, dispatch }, comment) => {
  // console.log(JSON.stringify(comment));
  commit(types.keywordUpdate, comment);
};

export const createKeyword = ({ commit, state, dispatch }, newProperties) => {
  log.debug('actions:createKeyword', newProperties);
  console.log(JSON.stringify(newProperties));
  var createdKeyword;
  return api
    .createKeyword(newProperties)
    .then((Keyword) => {
      createdKeyword = Keyword;
      return Keyword;
    })
    .then(async () => {
      console.log(JSON.stringify(createdKeyword));
      commit(types.setKeyword, createdKeyword);
      var newKeyword = await dispatch('loadKeyword', createdKeyword._id);
      logAction({ commit, state }, { Keyword: newKeyword, object: newKeyword, reason: 'Created Keyword' });
      return createdKeyword;
    })
    .catch((e) => {
      log.error('Error while creating Keyword', e);
      commit(types.setSyncStatus, { status: 'Error', live: 0, message: 'Database Error occurred', count: 1 });
    });
};

export const saveKeywordProperties = async ({ commit, state, dispatch }, update) => {
  log.debug('actions:saveKeywordProperties', update);
  console.log(JSON.stringify(update), JSON.stringify(state.setKeyword));

  if (update.newProperties) {
    if (!update.newProperties._id) {
      console.log(JSON.stringify(update));
      update.updateKeyword = await dispatch('createKeyword', update);
    }
    console.log(JSON.stringify(update));
  }
};
export const loadKeyword = async ({ commit, state, dispatch, getters }, _id) => {
  var keyword = await api.getKeyword(_id).catch((e) => {
    commit(types.setSyncStatus, { status: 'Active', live: 1, message: '', count: 1 });
    throw new Error('Unable to Keyword');
  });
  commit(types.setKeyword, keyword);
  return keyword;
};
export const updateStateKeyword = async ({ commit, state }) => {
  commit(types.setSyncStatus, { status: 'Active', live: 0, message: 'Loading Keyword', progress: 30 });
  let load = await api.loadKeyword();
  var keyword = await api.getKeyword(load[0].id).catch((e) => {
    commit(types.setSyncStatus, { status: 'Active', live: 1, message: '', count: 1 });
    throw new Error('Unable to Keyword');
  });
  commit(types.setKeyword, keyword);
};



// WEBPACK FOOTER //
// ./src/store/keyword/keywordActions.js